export * from './tick-tock';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/services/index.ts